import { createAction, props } from '@ngrx/store';
import { ContentPage } from '../../models';

export const LoadContentPages = createAction('[Content] Load Content Pages');
export const LoadContentPagesSuccess = createAction('[Content] Load Content Pages Success', props<{ contentPages: ContentPage[] }>());
export const LoadContentPagesFail = createAction('[Content] Load Content Pages Fail', props<{ error: any }>());

export const LoadContentPageBySlug = createAction('[Content] Load Content Page by Slug', props<{ slug: string }>());
export const LoadContentPageBySlugSuccess = createAction(
  '[Content] Load Content Page by Slug Success',
  props<{ page: ContentPage; slug: string }>()
);
export const LoadContentPageBySlugFail = createAction('[Content] Load Content Page by Slug Fail', props<{ slug: string; error: any }>());

export const LoadContentPageById = createAction('[Content] Load Content Page by Id', props<{ id: number }>());
export const LoadContentPageByIdSuccess = createAction('[Content] Load Content Page by Id Success', props<{ page: ContentPage }>());
export const LoadContentPageByIdFail = createAction('[Content] Load Content Page by Id Fail', props<{ id: number; error: any }>());
